import React from 'react';
import styled from '@emotion/styled';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const PaginationContainer = styled.div`
	@media (min-width: 992px) {
		max-width: 970px;
	}
	@media (min-width: 768px) and (max-width: 991px) {
		max-width: 720px;
	}
	@media (max-width: 767px) {
		max-width: 540px;
	}
	margin-left: auto;
	margin-right: auto;
	margin-bottom: 16px;
	.pagination-inner {
		align-items: center;
		display: flex;
		justify-content: flex-end;
		padding: 0.6rem 0;
		.pagination-label {
			margin-right: 0.6rem;
			list-style: none;
		}
		.pagination-button {
			border: 1px solid #ccc;
			color: #969696;
			align-items: center;
			display: flex;
			height: 32px;
			width: 32px;
			justify-content: center;
			background: white;
			border: 1px solid #cf004f;
			color: #cf004f;
		}
		.pagination-button:disabled,
		.pagination-button[disabled] {
			border-color: #ccc !important;
			color: #969696 !important;
		}
		.pagination-current {
			border: 0.1rem solid #ccc;
			height: 32px;
			width: 32px;
			display: flex;
			justify-content: center;
			align-items: center;
			margin: 0px 6px;
		}
		.pagination-current a {
			color: #000;
			text-decoration: none !important;
		}
		.pagination-button a {
			color: #cf004f;
			text-decoration: none !important;
		}
	}
`;

const Pagination = ({ current, total, next, prev, updatePageNo }) => {
	const history = useHistory();

	const buttonHandler = (e, buttonDir) => {
		e.preventDefault();
		const prevClicked = buttonDir === 'prev';
		const nextClicked = buttonDir === 'next';
		const isFirstPage = current === 1;
		const isTotalPage = current === total;
		const isFirstClicked = buttonDir === 1;
		const isNumberClicked = typeof buttonDir === 'number';
		if ((prevClicked && isFirstPage) || (nextClicked && isTotalPage)) {
			return false;
		}
		if (isNumberClicked && isFirstClicked) {
			const queryParams = history?.location?.search.replace(
				`?page=${current}`,
				''
			);
			history.replace({
				search: queryParams || ''
			});
		}
		updatePageNo(buttonDir);
		if (isNumberClicked && !isFirstClicked && buttonDir !== current) {
			history.push(`?page=${buttonDir}`);
		}
		return false;
	};

	return (
		<PaginationContainer>
			<ul className='pagination-inner'>
				<li className='pagination-label'>
					<b>Page {current}</b> of {total}
				</li>
				<li
					className={`pagination-${prev ? 'current' : 'button'} left-arrow`}
					onClick={(e) => buttonHandler(e, 'prev')}
				>
					<a
						onClick={(e) => buttonHandler(e, 'prev')}
						href='#'
						aria-current='page'
					>
						<span>{`<`}</span>
					</a>
				</li>
				{[...Array(total)].map((item, i) => (
					<li
						key={i + 1}
						className={
							current === i + 1 ? 'pagination-button' : 'pagination-current'
						}
						onClick={(e) => buttonHandler(e, i + 1)}
					>
						<a
							onClick={(e) => buttonHandler(e, i + 1)}
							href={`?page=${i + 1}`}
							aria-current='page'
						>
							{i + 1}
						</a>
					</li>
				))}
				<li
					className={`pagination-${next ? 'current' : 'button'} left-arrow`}
					onClick={(e) => buttonHandler(e, 'next')}
				>
					<a
						onClick={(e) => buttonHandler(e, 'next')}
						href='#'
						aria-current='page'
					>
						<span>{`>`}</span>
					</a>
				</li>
			</ul>
		</PaginationContainer>
	);
};

export default Pagination;
